import { loginByEmail, logout, getInfo } from '@/api/login';
// import Cookies from 'js-cookie';
import storeLocal from 'store';

const user = {
  state: {
    user: '',
    sid: '',
    login_type: '',
    // login: '',
    name: '',
    avatar: '',
    commonTabRoute: ''
  },

  mutations: {
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_SID: (state, sid) => {
      state.sid = sid;
    },
    SET_LOGIN_TYPE: (state, type) => {
      state.login_type = type;
    },
    SET_ISLOGIN: (state, login) => {
      state.login = login;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_COMMONTADROUTE: (state, commonTabRoute) => {
      state.commonTabRoute = commonTabRoute;
    }
  },

  actions: {
    // 邮箱登录
    // LoginByEmail({ commit }, userInfo) {
    //   const email = userInfo.email.trim();
    //   return new Promise((resolve, reject) => {
    //     loginByEmail(email, userInfo.password, 'WEBMAIL_PC', true).then(response => {
    //       const data = response.data;
    //       storeLocal.set('Pwm-Islogin', data.data.sid);
    //       CONST_CONFIG.urlParams = '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.userEmail;
    //       commit('SET_ISLOGIN', data.data.sid);
    //       commit('SET_USER', data.data.userEmail);
    //       commit('SET_SID', data.data.sid);
    //       commit('SET_LOGIN_TYPE', data.data.loginAppType);
    //       resolve();
    //     }).catch(error => {
    //       console.log(error)
    //       reject(error);
    //     });
    //   });
    // },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data;
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 登出
    LogOut({ commit, state }) {
      // console.log(state)
      return new Promise((resolve, reject) => {
        // logout(state.sid, state.login_type, state.user).then(() => {
        let urlParams = storeLocal.get('Pwm-urlParams');
        logout(urlParams).then(() => {
          // commit('SET_ISLOGIN', '');
          storeLocal.remove('Pwm-Islogin');
          storeLocal.remove('Pwm-user');
          storeLocal.remove('Pwm-password');
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js